const mediaItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20smartphone%20screen%20displaying%20abstract%20content%20in%20a%20dimly%20lit%20room%2C%20warm%20red%20glow%20reflecting%20on%20surfaces%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20dramatic%20shadows%2C%20no%20text%20no%20faces%20no%20people&width=600&height=340&seq=media-evidence-01&orientation=landscape",
    tag: '实锤视频',
    title: '顶流男星夜店亲密画面曝光，监控录像还原事件全过程',
    duration: '03:24',
    views: '256万',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20a%20recording%20studio%20with%20red%20on%20air%20sign%20glowing%2C%20dramatic%20lighting%20from%20equipment%20panels%2C%20professional%20broadcast%20atmosphere%2C%20cinematic%20photography%2C%20no%20text%20no%20faces%20no%20people&width=600&height=340&seq=media-evidence-02&orientation=landscape",
    tag: '独家录音',
    title: '知名导演私下言论录音流出，涉及多个剧组选角内幕',
    duration: '05:18',
    views: '189万',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20scene%20of%20scattered%20screenshots%20and%20documents%20illuminated%20by%20warm%20desk%20light%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20no%20text%20no%20faces%20no%20people&width=600&height=340&seq=media-evidence-03&orientation=landscape",
    tag: '聊天截图',
    title: '某女星与经纪人的微信聊天记录遭泄露，涉及片酬谈判细节',
    duration: '08:42',
    views: '134万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          实锤精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          有图有真相，视频录音截图一应俱全，吃瓜也要讲证据
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="bg-background-50 border border-background-200 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  onError={(e) => { const el = (e.currentTarget as HTMLElement); if (el.parentElement) el.parentElement.style.display = 'none'; }}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded font-mono">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 text-[11px] font-semibold rounded-full bg-accent-100 text-accent-700 mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 leading-relaxed mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}